var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPuertaAbierta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 194.38 255.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#040006;}.cls-2{fill:#278257;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-puerta-abierta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_32",
    "data-name": 32
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.08,97.62a11.73,11.73,0,0,1,11.71,11.72V230.82a11.72,11.72,0,0,1-11.71,11.71H24.3a11.73,11.73,0,0,1-11.72-11.71V109.34A11.74,11.74,0,0,1,24.3,97.62H170.08M97.19,0A60.76,60.76,0,0,0,36.45,60.74H59.53a37.66,37.66,0,1,1,75.32,0V85H24.3A24.36,24.36,0,0,0,0,109.34V230.82a24.37,24.37,0,0,0,24.3,24.3H170.08a24.38,24.38,0,0,0,24.3-24.3V109.34A24.37,24.37,0,0,0,170.08,85H157.93V60.74A60.76,60.76,0,0,0,97.19,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M97.19,143.7a26.38,26.38,0,1,0,26.38,26.38A26.4,26.4,0,0,0,97.19,143.7Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPuertaAbierta);
export default __webpack_public_path__ + "static/media/ic-puerta-abierta.b6451531430423d0cd6082c8ee9908a9.svg";
export { ForwardRef as ReactComponent };